module.exports = __webpack_public_path__ + "14four/static/media/att-globe.8324f4a5.svg";